module.exports = __webpack_public_path__ + "img/wz-4-2.46809917.png";